<app-view-dashboard-component [hideHeader]="true">
  <div modalTitle>
  </div>
  @defer(on timer(3000)) {
    <h1>Urakka</h1>
    @if (isBillingAccount()) {
      <h3>{{ 'register.created' | translate }}</h3>
      <p>{{ 'register.createdInfo' | translate }}</p>
      <ul>
        <li>
          <ion-icon name="checkmark-outline"></ion-icon>
          {{ 'register.steps.1' | translate }}
        </li>
        <li>
          <ion-icon name="checkmark-outline"></ion-icon>
          {{ 'register.steps.2' | translate }}
        </li>
        <li>
          <ion-icon name="arrow-forward-outline"></ion-icon>
          <strong>{{ 'register.steps.3' | translate }}</strong>
        </li>
        <li>
          <ion-icon name="arrow-forward-outline"></ion-icon>
          {{ 'register.steps.4' | translate }}
        </li>
      </ul>
      <div class="divider"></div>
      <ion-item lines="none"
        button="true"
        (click)="onIntro()">
        <ion-icon slot="start"
          name="briefcase-outline"></ion-icon>
        <ion-label>{{ 'register.fill' | translate }}</ion-label>
      </ion-item>
      <h4>{{ 'login.title' | translate }}</h4>
      <ion-item lines="none"
        button="true"
        [href]="'tel:' + telNumber">
        <ion-icon slot="start"
          name="call-outline"></ion-icon>
        <ion-label>{{ 'register.activate' | translate }}</ion-label>
      </ion-item>
      <ion-item lines="none"
        button="true"
        (click)="onDemo()">
        <ion-icon slot="start"
          name="star-outline"></ion-icon>
        <ion-label>{{ 'register.demo' | translate }}</ion-label>
      </ion-item>
      <h4>{{ 'register.partnersTitle' | translate }}</h4>
      <p>{{ 'register.partnersInfo' | translate }}</p>
      <!--
      @if (isIos) {
        <p class="order-ios">
          {{ 'stripe.orderAccount' | translate }}
        </p>
      } @else {
        <p>{{ 'stripe.orderAccount' | translate }}</p>
        @if (adminProduct$ | async; as product) {
          @if (product.currentPrice$ | async; as price) {
            <ion-item button="true"
              lines="none"
              (click)="onOrder(price)">
              <app-loading-button [loading]="loading()">
                <div>
                  <h4>{{ 'tickets.freemium.order' | translate }} <span
                      class="name">{{ 'product.admin.name' | translate }}</span></h4>
                  <p>{{ 'product.admin.description' | translate }}</p>
                </div>
              </app-loading-button>
              <div slot="end">
                {{ price.price | currency:'EUR' }}
              </div>
            </ion-item>
          }
        }
          }-->
    } @else {
      <p>{{ 'stripe.noActivated' | translate }}</p>
      <p>{{ billingAccountName() }}</p>
    }
    <div class="ion-margin-top">
      <ion-button color="light"
        shape="round"
        (click)="logout()">
        {{ 'profile.logout' | translate }}
      </ion-button>
    </div>
  } @placeholder {
    <div class="ion-margin-top">
      <app-loading></app-loading>
    </div>
  }
</app-view-dashboard-component>